import './App.scss';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/home/home';
import { Sponsorship } from './pages/sponsorship/sponsorship';

function App() {
  return (
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="sponsorship" exact element={<Sponsorship />} />
      {/* <Route path="services" exact element={<Services />} />
      <Route path="industries" exact element={<Industries />} />
      <Route path="about" exact element={<About />} />
      <Route path="contacts" exact element={<Contacts />} />
      <Route path="services/:area_id/:service_id?" exact element={<ServicesDetail />} />
      <Route path="insights" exact element={<Insights />} />
      <Route path="insights/news" exact element={<News />} /> */}
    </Routes>
  );
}

export default App;
